import React from "react"
import { 
  Alert,
  Button,
  Checkbox,
  Col,
  FormGroup,
  Radio,
  Row,
  Thumbnail
} from "react-bootstrap"
import apiServerApi from "../../redux/sagas/apiServerApi"
import { browserHistory } from "react-router"
import FontAwesome from "react-fontawesome"
import { fillingZeroUtility, LoanCollateral, getPlural } from "../../lib/utils"
import { blockingFetchService } from "../../lib/blockingFetch"
import authServerApi from "../../redux/sagas/authServerApi"
import ImpersonationModalForm from "./ImpersonationModalForm"
import moment from "moment"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"

class OrganizationDetailForm extends React.Component {

  state = {
    running: false,
    error: null,
    impersonate: false,
  }

  componentDidMount() {
    const { organization } = this.props
    if(organization) {
      this.checkAdminCreation(organization.email)
    }
  }

  impersonateClicked = () => this.setState({ impersonate: true })

  checkAdminCreation = email => {

    this.setState({
      error: null,
      running: true,
    })

    blockingFetchService(
      accessToken => authServerApi.getByUsername(accessToken, email), 
      _ => {},
      error => {
        if(error.status === 404) {
          this.setState({ error: 'Email was not sent to the admin!' })
        }
      },
      _ => this.setState({ running: false })
    )
  }

  fixAdminCreation = organization => {

    this.setState({
      error: null,
      running: true,
    })

    blockingFetchService(
      accessToken => apiServerApi.fixAdminCreation(accessToken, organization.id), 
      _ => this.checkAdminCreation(organization.email),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  /**
   * Render Loans Collaterals
   * 
   * @returns JSX
   */
   renderLoanCollateral = loanCollaterals => {

    let collateralValues = [],
    checkedValues = [],
    index = 0

    for(let col in LoanCollateral) {
      collateralValues[index] = LoanCollateral[col]

      if(loanCollaterals.indexOf(col) > -1) {
        checkedValues.push(index)
      }
      index++
    }

    return (
      <div>
      {
        collateralValues.map((value, index) => (
        <span key={index}>
          <Checkbox readOnly inline checked={ checkedValues.indexOf(index) > -1 }>
            { value }
          </Checkbox> &nbsp; &nbsp; 
        </span>
        ))
      }
      </div>
    )
  }

  render() {

    const { organization } = this.props
    if(!organization) return

    const { running, error, impersonate } = this.state,
    { id, name, iconId, active, openedOn, email, deviceApiKey, nbDaysManualExtension: nbDays,
      canLinkToExistingDevice, customerFields, documentFields, loanCollaterals } = organization,
    
    dataBreadCrumbs = [{ url: '/organizations', title: 'Organizations' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ name } data={ dataBreadCrumbs } />

        <Row>

          <Col md={5}>
            <Thumbnail href="#"
              alt={ name } 
              src={ iconId ?
                apiServerApi.organizationIconURL(id) : require('../../files/company-logo.png')} />
          </Col>

          <Col md={7} className='organization-detail-content'>

            { running ?
              <Alert bsStyle="info" className="mr-15">
                <strong>Running..</strong>
              </Alert>

              : error ?
                <Alert bsStyle="danger" className="mr-15">
                  <p><FontAwesome name="exclamation-circle" size="lg" /> { error }</p>
                  <p className="cursor-pointer" onClick={() => this.fixAdminCreation(organization)}>
                    <FontAwesome name="hand-o-right" size="lg" /> <strong>Please click here to repair.</strong>
                  </p>
                </Alert>
              : null 
            }

            <h2 className='blue'>{ name }</h2>

            <Row>
              <Col xs={4}><strong>Status</strong></Col>
              <Col xs={8}>
                <FormGroup>
                  <Radio readOnly name="status" inline checked={ active }>
                    Active
                  </Radio>{' '}
                  <Radio readOnly name="status" inline checked={ !active }>
                    Inactive
                  </Radio>
                </FormGroup>
                <hr/>
              </Col>
            </Row>

            <Row>
              <Col xs={4}><strong>Opened On</strong></Col>
              <Col xs={8}>
                { moment(openedOn).format('LL') }
                <hr/>
              </Col>
            </Row>

            <Row>
              <Col xs={4}><strong>Email</strong></Col>
              <Col xs={8}>
                { email }
                <hr/>
              </Col>
            </Row>

            <Row>
              <Col xs={4}><strong>Device Api Key</strong></Col>
              <Col xs={8}>
                { deviceApiKey }
                <hr/>
              </Col>
            </Row>

            <Row>
              <Col xs={4}><strong>Max manual extension</strong></Col>
              <Col xs={8}>
                { nbDays === 0 ? 'Disabled' : `${ fillingZeroUtility(nbDays) } ${ getPlural('day', nbDays) }` }
                <hr/>
              </Col>
            </Row>

            <Row>
              <Col xs={4}><strong>Loans Collaterals</strong></Col>
              <Col xs={8}>
                { this.renderLoanCollateral(loanCollaterals) }
                <hr/>
              </Col>
            </Row>

            <Row>
              <Col xs={4}><strong>Can creators link a loan to an existing device?</strong></Col>
              <Col xs={8}>
                <FormGroup>
                  <Radio readOnly name="canLinkToExistingDevice" inline checked={ canLinkToExistingDevice }>
                    Yes
                  </Radio>{' '}
                  <Radio readOnly name="canLinkToExistingDevice" inline checked={ !canLinkToExistingDevice }>
                    No
                  </Radio>
                </FormGroup>
                <hr/>
              </Col>
            </Row>

            <Row>
              <Col xs={4}><strong>Customer information</strong></Col>
              <Col xs={8}>
                { customerFields ? customerFields.map((item, index) =>
                  <li key={index}>
                    { item.label }
                    <span className="gray"> - { item.type }</span>
                    { !item.mandatory ? <small className="gray"> - Optional</small> : null }
                  </li>)
                : null
                }
              <hr/>
              </Col>
            </Row>

            <Row>
              <Col xs={4}><strong>Customer documents</strong></Col>
              <Col xs={8}>
               { documentFields ? documentFields.map((item, index) =>
                  <li key={index}>
                    { item.label }
                    { !item.mandatory ? <small className="tip"> - Optional</small> : null }
                  </li>)
                : null
                }
              </Col>
            </Row>

            <hr/>

            <div className='align-right p-20'>

              <Button bsStyle="danger" onClick={ this.impersonateClicked }
                className="mr-15">
                <FontAwesome name='user-md' size="lg"/> Impersonate
              </Button>

              <Button bsStyle="primary" onClick={() => browserHistory.push(`/organizations/${id}/update`)}>
                <FontAwesome name='pencil' size="lg"/> Update
              </Button> &nbsp;

              <Button bsStyle="success" onClick={() => browserHistory.push('/organizations/create')}>
                <FontAwesome name='plus-circle' size="lg"/> New Organization
              </Button>
            </div>

          </Col>
        </Row>

        <ImpersonationModalForm
          organization={ organization }
          show={ impersonate }
          close={() => this.setState({ impersonate: false })}
        />
      </div>
    )
  }
}

export default OrganizationDetailForm



// WEBPACK FOOTER //
// ./src/components/Organizations/OrganizationDetailForm.js